module.exports = __webpack_public_path__ + "static/media/autokar (2).33f2ecbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar (2).jpg
// module id = 843
// module chunks = 0